export function getDisplayName(
	user: {
		firstName?: string | null;
		lastName?: string | null;
		email?: string | null;
	} | null,
): string {
	if (!user) return "You";
	const firstName = user.firstName?.trim() || "";
	const lastName = user.lastName?.trim() || "";

	if (firstName && lastName) return `${firstName} ${lastName}`;
	if (firstName) return firstName;
	if (lastName) return lastName;
	if (user.email) {
		// Try to make a nice display name from email
		const [username] = user.email.split("@");
		// Convert something like "john.doe" or "john_doe" to "John Doe"
		return username
			.split(/[._-]/)
			.map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
			.join(" ");
	}
	return "You";
}
